import React from "react";
import { BillingCompanyContext } from "./BillingCompanyProvider.context";

import { getBillingCompanyFromStorage } from "./BillingCompanyProvider.storage";
import { ICompanyOutlet } from "../../redux/companyOutlet/companyOutlet.types";

export function useBillingCompanyContext() {
	const context = React.useContext(BillingCompanyContext);

	if (!context) {
		throw new Error(
			"BillingCompanyContext: Context must be used inside AuthProvider"
		);
	}

	return context;
}

export const useBillingCompanyFromStorage = (): ICompanyOutlet => {
	const [billing_info] = React.useState<ICompanyOutlet>(() => {
		return getBillingCompanyFromStorage();
	});

	return billing_info;
};
